import React from "react";
import { cva, type VariantProps } from "cva";
import { LinearProgress } from "@mui/material";

const buttonVariants = cva(
    "relative overflow-hidden inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background space-x-2",
    {
        variants: {
            variant: {
                default: "bg-[#7556FA] text-white hover:bg-[#7556FA]/90 border-none",
                outline: "bg-white text-[#7556FA] border border-gray-300 hover:border-[#7556FA]",
            },
            size: {
                sm: "text-xs",
                md: "px-4 py-2 text-md",
                lg: "px-8 py-3 text-[16px]",
            }
        },
        defaultVariants: {
            variant: "default",
            size: "md"
        }
    }
);

type UIButtonProps = React.ComponentProps<"button"> & VariantProps<typeof buttonVariants> & {
    loading?: boolean;
};

export default function UIButton({
    className,
    size,
    variant,
    loading,
    disabled,
    children,
    ...props
}: UIButtonProps) {
    return (
        <button
            className={buttonVariants({ variant, size, className })}
            disabled={loading || disabled}
            {...props}
        >
            {children}
            {loading && (
                <div className="absolute top-0 left-0 w-full h-full opacity-20">
                    <LinearProgress sx={{ height: "100%" }} />
                </div>
            )}
        </button>
    );
}
